import { render, staticRenderFns } from "./AutocompleteTeacherCard.vue?vue&type=template&id=22300f45"
import script from "./AutocompleteTeacherCard.vue?vue&type=script&lang=js"
export * from "./AutocompleteTeacherCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports